import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import moment from 'moment'

import "./styles/custom.scss"

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

store.dispatch('initialSetup')
    .then(() => {
        new Vue({
            router,
            store,
            vuetify,
            i18n,
            render: h => h(App)
        }).$mount('#app');
    })
    .catch((error) => {
        console.log(error);
    });


